// Auto-close "Added to cart" popup, but pause on hover/touch/scroll
(function () {
  var CLOSE_DELAY = 6000; // change to 3000 for ~3s
  var timer = null;

  function popup() { return document.querySelector('.added-notice'); }
  function visible(el){ return !!el && (el.offsetParent !== null || getComputedStyle(el).display !== 'none'); }
  function onCartPage(){ return location.pathname.indexOf('/cart') === 0; }

  function closePopup() {
    var p = popup(); if (!p) return;
    var btn = p.querySelector('[data-added-notice-close], .added-notice__close, .js-added-notice-close, [aria-label="Close"]');
    if (btn) btn.click(); else p.style.display = 'none';
  }

  function clearT(){ if (timer) { clearTimeout(timer); timer = null; } }
  function schedule(){ if (onCartPage()) return; clearT(); timer = setTimeout(closePopup, CLOSE_DELAY); }

  function bindPauseHandlers(p){
    // Desktop hover + focus
    p.addEventListener('mouseenter', clearT);
    p.addEventListener('mouseleave', schedule);
    p.addEventListener('focusin',  clearT);
    p.addEventListener('focusout', schedule);
    // Mobile touch + scroll (acts like hover)
    p.addEventListener('touchstart', clearT, {passive:true});
    p.addEventListener('touchend',   schedule, {passive:true});
    p.addEventListener('touchcancel',schedule, {passive:true});
    p.addEventListener('pointerdown',clearT);
    p.addEventListener('pointerup',  schedule);
    p.addEventListener('wheel',      clearT, {passive:true});
    p.addEventListener('scroll',     clearT, {passive:true});
  }

  // Watch for popup appearing, then bind + schedule
  var mo = new MutationObserver(function(){
    var p = popup();
    if (!p || !visible(p)) return;
    bindPauseHandlers(p);
    schedule();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Re-schedule after AJAX cart changes
  var _fetch = window.fetch;
  window.fetch = function(){
    var out = _fetch.apply(this, arguments);
    try {
      var url = (arguments[0] && arguments[0].url) || arguments[0];
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
        out.finally(function(){ setTimeout(schedule, 200); });
      }
    } catch(e){}
    return out;
  };
})();
